import { useQuery } from 'react-query';

import Api from '../api';
import { Sector } from '../model/sector';

const QueryKey = {
  Sectors: ['sectors'],
};

export function useGetSectors(
  enabled = true,
  { onSuccess }: { onSuccess?: (data: Sector[]) => void } | undefined = {},
) {
  return useQuery<Sector[], Error>(QueryKey.Sectors, Api.getSectors, {
    enabled,
    onSuccess,
    refetchOnReconnect: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
}
